//imports
import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { Routes, Route, Navigate } from 'react-router-dom';

//views
import MainView from 'Modules/fleet/views/main';

import { HasPermission } from 'Core/security';

//router
const routerFleet = ({ }) => {

	const user = useSelector(state => state.securityRedux.user)

	return (
		<Routes>
			{
				HasPermission(user, "vstat", [103]) &&
				<Fragment>
					<Route path='/' element={<Navigate to="/app/fleet/main" />}></Route>
					<Route path='main' element={<MainView />} />
				</Fragment>
			}
			<Route path="*" element={<Navigate to="/app/error" />} />
		</Routes>
	);
};

export default routerFleet
